import {Component, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import moment from 'moment';
import * as EmailValidator from 'email-validator';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {ReportService} from '@app/shared/services/report.service';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {UtilsInjectable} from '@app/shared';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    SelectDropDownModule,
    NgbPaginationModule,
    PaginationComponent
  ]
})
export class CustomerComponent implements OnInit {

  public now = new Date();
  public date: any;
  public user_rights: any = {};
  start = 0;
  limit = 15;
  p = 50;
  public collection: any = '';
  page = 1;
  public user_data: any = {};
  public splitted: any = [];
  public customer_data: any =
    {
      customer_code: '',
      customer_name: '',
      user_id: '',
      customer_address: '',
      customer_phoneno: '',
      customer_email: '',
      search_customer: '',
      credit_period: '',
      file_name: '',
      customer_trn: '',
      state: '',
      vat_no: '',
      customer_id: 0,
    }

  index: any;
  public customers_data: any = [];
  status: any;
  public fileName: any = '';
  public image: any = "";

  constructor(private loaderService: LoaderService,
              public reportService: ReportService,
              public consultingService: ConsultingService,
              private toastr: ToastrService,
              protected utils: UtilsInjectable
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.customer_data.user_id = this.user_data.user_id;
    this.formatDateTime();
    this.getcustomerList();
  }

  public savecustomer(): any {
    if (this.customer_data.customer_name == "") {
      this.toastr.error('Please enter the customer name!');
      return false;
    }
    if (this.customer_data.customer_email != '') {
      if (!EmailValidator.validate(this.customer_data.customer_email)) {
        this.toastr.error('Please enter proper email !');
        return false;
      }
    }
    if (this.image != '') {
      this.splitted = this.image.split(",");
    }
    if (this.fileName == "") {
      this.splitted[1] = ''
    }
    const postData = {
      user_id: this.user_data.user_id,
      customer_id: this.customer_data.customer_id,
      customer_code: this.customer_data.customer_code,
      customer_name: this.customer_data.customer_name,
      customer_address: this.customer_data.customer_address,
      customer_phoneno: this.customer_data.customer_phoneno,
      customer_email: this.customer_data.customer_email,
      base64_file_str: this.splitted[1],
      credit_period: this.customer_data.credit_period,
      customer_trn: this.customer_data.customer_trn,
      state: this.customer_data.state,
      vat_no: this.customer_data.vat_no,
      file_name: this.fileName
    }
    this.loaderService.display(true);
    this.consultingService.saveCustomer(postData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.getcustomerList();
        this.clearcustomer();
        this.index = result.data_id;
        this.customer_data.customer_code = result.customer_code;
      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public getcustomer() {
    const post2Data = {
      customer_id: this.customer_data.customer_id
    }
    this.loaderService.display(true);
    this.consultingService.getCustomer(post2Data).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.customers_data = result['data'];
        this.loaderService.display(false);
      }
    });
  }

  public clearcustomer() {
    this.customer_data = {
      customer_name: '',
      user_id: '',
      customer_address: '',
      customer_phoneno: '',
      customer_email: '',
      search_customer: '',
      credit_period: '',
      file_name: '',
      customer_trn: '',
      state: '',
      vat_no: '',
      customer_id: 0,
    }
    this.customer_data.customer_id = 0;
    this.fileName = "";
    this.getcustomerList();
  }

  public getcustomerList(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      vednor_id: '0'
    };
    this.loaderService.display(true);
    this.consultingService.listCustomer(postData).subscribe((result: any) => {
      this.customer_data.customer_code = result['customer_code']['data'];
      if (result['status'] == 'Success') {
        this.customers_data = result['data'];
        this.collection = result['total_count'];
      } else {
        this.customers_data = [];
        this.collection = 0;
      }
      this.loaderService.display(false);
    });
  }

  public clear_search() {
    if (this.customer_data.search_customer != '') {
      this.clearcustomer();
      this.getcustomerList();
    }
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.customer_data.search_customer,
      customer_id: '0'
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.listCustomer(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.customers_data = result['data'];
        this.collection = result['total_count'];
        const i = this.customers_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public editcustomer(customer: any) {
    this.customer_data.customer_code = customer.CUSTOMER_CODE;
    this.customer_data.customer_name = customer.CUSTOMER_NAME;
    this.customer_data.customer_address = customer.CUSTOMER_ADDRESS;
    this.customer_data.customer_phoneno = customer.CUSTOMER_PHONE;
    this.customer_data.customer_email = customer.CUSTOMER_EMAIL;
    this.customer_data.state = customer.CUSTOMER_STATE;
    this.customer_data.vat_no = customer.VAT_NO
    this.customer_data.customer_id = customer.CUSTOMER_ID;
    window.scrollTo(0, 0);
  }

  public formatDateTime() {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y h:mm a');
    }
  }

  deleteCustomer(cust_id:any){
    const confirmed = confirm('Are you sure you want to delete this customer?');
    if (confirmed) {
      this.loaderService.display(true);
      this.consultingService.deleteCustomer({customer_id : cust_id}).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.getcustomerList();
          this.toastr.success(result["msg"]);
        }else{
          this.toastr.error(result["msg"]);
        }
        this.loaderService.display(false);
      });
    }
  }

}
